<template>
  <grid-row>
    <grid-column>
      <form-field-input
        label="Title"
        v-model="form.title"
        :validation-errors="validationErrors.title"
      ></form-field-input>

      <form-field-input
        label="Location"
        v-model="form.location"
        :validation-errors="validationErrors.location"
      ></form-field-input>

      <form-field-start-at-end-at-picker
        :start-at.sync="form.start_at"
        :end-at.sync="form.end_at"
        :start-at-validation-errors="validationErrors.start_at || []"
      ></form-field-start-at-end-at-picker>

      <form-field-collection
        label="User Attendees"
        v-model="selectedUsers"
        field="full_name"
        :options="$store.getters.activeUsers"
        placeholder="choose users"
      ></form-field-collection>

      <form-field-collection
        label="Contact Attendees"
        v-model="selectedContacts"
        field="full_name"
        :options="$store.state.activeRecord.contacts"
        placeholder="choose contacts"
      ></form-field-collection>

      <form-validation-errors :validation-errors="validationErrors.attendees"></form-validation-errors>

      <form-field-editor
        label="Description"
        v-model="form.description"
        :validation-errors="validationErrors.description"
        type="appointment"
      ></form-field-editor>

<!--      <form-field-switch-->
<!--        label="Update Lead Status Change Date"-->
<!--        v-model="form.set_due_at"-->
<!--        :validation-errors="validationErrors.set_due_at"-->
<!--        description="This will set the Lead Status Change Date (when lead will go red) to this appointment date"-->
<!--      ></form-field-switch>-->
    </grid-column>

    <grid-column>
      <h3 class="appointment--subheading">Appointment Reminders</h3>
      <p class="appointment--description">We will send a text and/or email to either the contact or user attendees.<br>NOTE:
        you can change the defaults in
        <router-link :to="{name: 'settings', params: {tab: 'appointment'}}">appointment settings</router-link>
      </p>

      <template v-if="hasEmailIntegration || hasPhoneIntegration">
        <hr>

        <form-field-switch
          label="Send Contact Reminders"
          v-model="defaultReminder.send_contact_reminders"
          size=""
        ></form-field-switch>

        <template v-if="defaultReminder.send_contact_reminders">
          <form-field-time-in-minutes
            label="Time before sending reminders"
            v-model="defaultReminder.time_before_contact_reminders"
          ></form-field-time-in-minutes>

          <!-- Contact Text Reminder -->
          <template v-if="hasPhoneIntegration">
            <form-field-switch
              label="Send Text Reminder?"
              v-model="defaultReminder.send_contact_text_reminder"
              size=""
            ></form-field-switch>

            <form-field-select-integration-phone-number
              v-if="defaultReminder.send_contact_text_reminder"
              label="From Phone Number"
              v-model="defaultReminder.integration_phone_number_id"
              :has-empty-option="false"
            ></form-field-select-integration-phone-number>

            <form-field-editor
              v-if="defaultReminder.send_contact_text_reminder"
              label="Text Reminder Message"
              type="textContactWithRecord"
              short-code-type="record"
              v-model="defaultReminder.contact_text_reminder"
            ></form-field-editor>
          </template>
          <!--No Phone Integration Message-->
          <div v-else>
            <p class="appointment--no_integration">Please set up your
              <router-link :to="{name: 'settings', params: {tab: 'phone'}}">phone integration</router-link>
              in order to send text reminders
            </p>
          </div>

          <!-- Contact Email Reminder -->
          <template v-if="hasEmailIntegration">
            <form-field-switch
              label="Send Email Reminder?"
              v-model="defaultReminder.send_contact_email_reminder"
              size=""
            ></form-field-switch>

            <form-field-select-user-emails
              v-if="defaultReminder.send_contact_email_reminder"
              class="mb-75"
              label="From Email"
              v-model="defaultReminder.user_id"
            ></form-field-select-user-emails>

            <form-field-editor
              v-if="defaultReminder.send_contact_email_reminder"
              label="Email Reminder Message"
              type="email"
              short-code-type="record"
              v-model="defaultReminder.contact_email_reminder"
            ></form-field-editor>
          </template>
          <!--No Email Integration Message-->
          <div v-else>
            <p class="appointment--no_integration">Please set up your
              <router-link :to="{name: 'settings', params: {tab: 'email'}}">email integration</router-link>
              in order to send email reminders
            </p>
          </div>
        </template>

        <hr>

        <form-field-switch
          label="Send User Reminders"
          v-model="defaultReminder.send_user_reminders"
          size=""
        ></form-field-switch>

        <template v-if="defaultReminder.send_user_reminders">
          <template v-if="usersHasTurnOffTextReminder.length !== 0">
            <p class="appointment--description">
              <strong>NOTE:</strong>
              <span v-for="(user, index) in usersHasTurnOffTextReminder" :key="user.id"><template v-if="index !== 0">, </template>{{ user.full_name }}</span>
              has appointment text reminders <strong>turned off</strong> in their profile settings.
            </p>
          </template>

          <template v-if="hasPhoneIntegration">
            <form-field-editor
              label="Text Reminder Message"
              type="textContactWithRecord"
              short-code-type="record"
              v-model="defaultReminder.user_text_reminder"
            ></form-field-editor>
          </template>
          <!--No Phone Integration Message-->
          <div v-else>
            <p class="appointment--no_integration">Please set up your
              <router-link :to="{name: 'settings', params: {tab: 'phone'}}">phone integration</router-link>
              in order to send text reminders
            </p>
          </div>

          <template v-if="usersHasTurnOffEmailReminder.length !== 0">
            <p class="mt-4 appointment--description">
              <strong>NOTE:</strong>
              <span v-for="(user, index) in usersHasTurnOffEmailReminder" :key="user.id"><template v-if="index !== 0">, </template>{{ user.full_name }}</span>
              has appointment email reminders <strong>turned off</strong> in their profile settings.
            </p>
          </template>

          <template v-if="hasEmailIntegration">
            <form-field-editor
              label="Email Reminder Message"
              type="email"
              short-code-type="record"
              v-model="defaultReminder.user_email_reminder"
            ></form-field-editor>
          </template>
          <!--No Email Integration Message-->
          <div v-else>
            <p class="appointment--no_integration">Please set up your
              <router-link :to="{name: 'settings', params: {tab: 'email'}}">email integration</router-link>
              in order to send email reminders
            </p>
          </div>
        </template>
      </template>
      <!--No Phone or Email Integration Message-->
      <div v-else>
        <p class="appointment--no_integration">Please set up your
          <router-link :to="{name: 'settings', params: {tab: 'email'}}">email integration</router-link> and/or <router-link :to="{name: 'settings', params: {tab: 'phone'}}">phone integration</router-link>
          in order to send appointment reminders
        </p>
      </div>

    </grid-column>

    <appointment-delete-form
      ref="appointmentDeleteModal"
    ></appointment-delete-form>
  </grid-row>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import {MODELS} from "../services/models";
import FormFieldStartAtEndAtPicker from "../components/form/FormFieldStartAtEndAtPicker";
import FormValidationErrors from "../components/form/FormValidationErrors";
import AppointmentDeleteForm from "./AppointmentDeleteForm";
import dates from "../services/dates";

export default {
  name: "AppointmentForm",
  components: {
    AppointmentDeleteForm,
    FormValidationErrors,
    FormFieldStartAtEndAtPicker
  },
  props: ["formData"],
  mixins: [FormMixin],
  data() {
    let activeRecord = this.$store.state.activeRecord;
    let property = activeRecord.property;

    return {
      form: {},
      validationErrors: {},
      selectedUsers: [],
      selectedContacts: [],
      defaultForm: {
        title: "Seller Appointment",
        location: (property.line_1) ? property.line_1 + " " + property.city + " " + property.state + " " + property.postcode : null,
        start_at: dates.getNowISO(1, true),
        end_at: dates.getNowISO(2, true),
        integration_event_id: null,
        event_url: null,
        record_id: activeRecord.record.id,
        attendees: [],
        set_due_at: false,
        reminders: [],
        description: null
      },
      defaultReminder: {
        user_id: this.$store.getters.authUser.id,
        integration_phone_number_id: null,
        send_user_reminders: false,
        user_text_reminder: "",
        user_email_reminder: "",
        send_contact_reminders: false,
        time_before_contact_reminders: null,
        send_contact_text_reminder: false,
        contact_text_reminder: "",
        send_contact_email_reminder: false,
        contact_email_reminder: "",
      }
    };
  },
  created() {
    this.form = this.$utils.clone(this.defaultForm);
    this.defaultReminder = this.$utils.clone({...this.defaultReminder, ...this.$store.getters.defaultAppointmentReminder});

    // See if lead campaign has phone number integration, then used it as default
    const campaignId = (this.form.record_id && this.record) ? this.record.campaign_id : null;
    const campaign = this.campaigns.find(campaign => campaign.id === campaignId);

    if (this.hasPhoneIntegration) {
      this.defaultReminder.integration_phone_number_id = (campaign && campaign.integrationPhoneNumber)
        ? campaign.integrationPhoneNumber.id
        : this.integrationPhoneNumbers[0].id;
    }

    if (this.formData) {
      this.form = this.$utils.clone({...this.form, ...this.formData});
      this.defaultReminder = this.$utils.clone({...this.defaultReminder, ...this.formData.reminders[0]});
    }

    this.splitAttendees(this.form.attendees);
  },
  computed: {
    activeRecord() {
      return this.$store.state.activeRecord;
    },
    record() {
      return this.activeRecord.record;
    },
    property() {
      return this.activeRecord.property;
    },
    contact() {
      return this.activeRecord.contact;
    },
    campaigns() {
      return this.$store.getters.campaigns;
    },
    integrationPhoneNumbers() {
      return this.$store.getters.integrationPhoneNumbers;
    },
    activeUsers() {
      return this.$store.getters.activeUsers;
    },
    hasPhoneIntegration() {
      return this.$store.getters.hasPhoneIntegration && this.$store.getters.account.has_phone_integration_feature && this.integrationPhoneNumbers.length;
    },
    hasEmailIntegration() {
      return this.$store.getters.emailIsIntegrated && this.$store.getters.account.has_email_integration_feature;
    },
    usersHasTurnOffTextReminder() {
      return this.selectedUsers.filter(selectedUser => {
        return this.activeUsers.find(user => {
          return user.id === selectedUser.id && user.time_before_text_appointment_reminder === null
        })
      });
    },
    usersHasTurnOffEmailReminder() {
      return this.selectedUsers.filter(selectedUser => {
        return this.activeUsers.find(user => {
          return user.id === selectedUser.id && user.time_before_email_appointment_reminder === null
        })
      });
    },
  },
  watch: {
    "form.attendees"(newValue) {
      this.splitAttendees(newValue);
    },
  },
  methods: {
    splitAttendees(attendees) {
      // Split up users and contacts
      this.selectedUsers = attendees.filter(a => a.class_name === MODELS.User.class_name);
      this.selectedContacts = attendees.filter(a => a.class_name === MODELS.Contact.class_name);
    },
    update() {
      this.form.attendees = [
        ...this.selectedContacts,
        ...this.selectedUsers
      ];
      this.form.reminders[0] = this.defaultReminder;

      return this.$api.appointments.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Appointment was updated",
            type: "is-success"
          });

          return res;
        });
    },
    create() {
      this.form.attendees = [
        ...this.selectedContacts,
        ...this.selectedUsers
      ];
      this.form.reminders[0] = this.defaultReminder;

      return this.$api.appointments.create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Appointment was created",
            type: "is-success"
          });

          return res;
        });
    },
    delete() {
      return new Promise((resolve, reject) => {
        this.$refs.appointmentDeleteModal.open(this.form);
        reject("open delete modal");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables/variables";

.appointment--subheading {
  margin-bottom: 6px;
  font-size: 1.25rem;
}

.appointment--description {
  margin-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.4;
}

.appointment--no_integration {
  margin: 1rem 0;
  padding: 1rem 0;
  border-top: 1px solid $border;
  border-bottom: 1px solid $border;
  font-weight: bold;
  line-height: 1.25;
}
</style>
